// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lY_l","colMin":"styles_colMin__2QmbZ"};